import React, { Component } from 'react';
import styles from './Loading.css';

// eslint-disable-next-line react/prefer-stateless-function
export class Loading extends Component {
  render() {
    return (
      <div className={styles.spinner}>
        <div className={styles.bounce1} />
        <div className={styles.bounce2} />
        <div className={styles.bounce3} />
      </div>
    );
  }
}

Loading.displayName = 'Loading';

export default Loading;
